@if (userSession && !isExternal) {
    <span>
        <button
            class="!tw-text-white"
            aria-label="user-profile"
            mat-button
            [matMenuTriggerFor]="usermenu"
            #userMenuTrigger="matMenuTrigger"
            [matTooltip]="getRoleTooltipContent()"
            matTooltipClass="linebreak-tooltip">
            <mat-icon fontSet="material-symbols-outlined">person</mat-icon>
            <span class="tw-hidden md:tw-inline-flex tw-whitespace-nowrap">{{
                userSession.fullName
            }}</span>
        </button>
    </span>
}
<mat-menu #usermenu="matMenu">
    @if (showRolesMenu) {
        <button
            aria-label="role-switch"
            mat-menu-item
            [matMenuTriggerFor]="siteMenu">
            {{ 'USER-PROFILE.ROLE-SWITCH' | translate }}
        </button>
    }
    <button
        mat-menu-item
        (click)="openSettings()">
        {{ 'USER-PROFILE.SETTINGS' | translate }}
    </button>
    @if (hideRating) {
        <button
            mat-menu-item
            (click)="onSetRatingDialog('false')">
            {{ 'USER-PROFILE.FEEDBACK-ON' | translate }}
        </button>
    }
    @if (!hideRating) {
        <button
            mat-menu-item
            (click)="onSetRatingDialog('true')">
            {{ 'USER-PROFILE.FEEDBACK-OFF' | translate }}
        </button>
    }
</mat-menu>

<mat-menu #siteMenu="matMenu">
    @if (userSession) {
        <div class="tw-flex tw-flex-col">
            @for (site of sitesInfo; track site) {
                <div
                    mat-menu-item
                    [matTooltip]="
                        (site._key === currentSite._key
                            ? 'HEADER.CURRENT_SITE'
                            : ''
                        ) | translate
                    "
                    (click)="$event.stopPropagation()"
                    matTooltipPosition="below"
                    class="tw-cursor-default"
                    [ngClass]="site._key === currentSite._key ? 'active' : ''">
                    <div
                        class="tw-flex tw-justify-between tw-items-center tw-w-full">
                        <div class="tw-flex tw-text-sm">
                            <span class="tw-mx-2">{{ site.fullSiteName }}</span>
                            @if (
                                sessionService
                                    .getUserRole(site)
                                    ?.includes('remote')
                            ) {
                                <span>
                                    ({{
                                        'USER-PROFILE.READ-ONLY' | translate
                                    }})</span
                                >
                            }
                            @if (sessionService.isOnlySiteAdmin(site)) {
                                <span
                                    class="tw-mx-2 tw-text-xs tw-text-gray-500">
                                    {{ 'HEADER.ROLES.SITEADMIN' | translate }}
                                </span>
                            }
                        </div>
                        <div class="tw-grid tw-grid-cols-3">
                            <span class="tw-min-w-[40px] tw-col-span-1">
                                @if (
                                    sessionService.isConsignor(site) &&
                                    !sessionService.isOnlySiteAdmin(site)
                                ) {
                                    <button
                                        aria-label="consignor-role-switch"
                                        mat-icon-button
                                        (click)="
                                            onChangeRole('consignor', site);
                                            userMenuTrigger.closeMenu()
                                        "
                                        [matTooltip]="
                                            'HEADER.ROLES.CONSIGNOR' | translate
                                        "
                                        matTooltipPosition="below">
                                        <img
                                            src="./assets/images/direction.svg"
                                            width="20"
                                            [alt]="
                                                'HEADER.ROLES.CONSIGNOR'
                                                    | translate
                                            " />
                                    </button>
                                }
                            </span>
                            <span class="tw-min-w-[40px] tw-col-span-1">
                                @if (
                                    sessionService.isCarrier(site) &&
                                    !sessionService.isOnlySiteAdmin(site)
                                ) {
                                    <button
                                        mat-icon-button
                                        (click)="
                                            onChangeRole('carrier', site);
                                            userMenuTrigger.closeMenu()
                                        "
                                        [matTooltip]="
                                            'HEADER.ROLES.CARRIER' | translate
                                        "
                                        matTooltipPosition="below">
                                        <img
                                            src="./assets/images/truck.svg"
                                            width="20"
                                            [alt]="
                                                'HEADER.ROLES.CARRIER'
                                                    | translate
                                            " />
                                    </button>
                                }
                            </span>
                            <span class="tw-min-w-[40px] tw-col-span-1">
                                @if (
                                    sessionService.isConsignee(site) &&
                                    !sessionService.isOnlySiteAdmin(site)
                                ) {
                                    <button
                                        aria-label="consignee-role-switch"
                                        mat-icon-button
                                        (click)="
                                            onChangeRole('consignee', site);
                                            userMenuTrigger.closeMenu()
                                        "
                                        [matTooltip]="
                                            'HEADER.ROLES.CONSIGNEE' | translate
                                        "
                                        matTooltipPosition="below">
                                        <img
                                            src="./assets/images/folder_checked.svg"
                                            width="20"
                                            [alt]="
                                                'HEADER.ROLES.CONSIGNEE'
                                                    | translate
                                            " />
                                    </button>
                                }
                            </span>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
</mat-menu>
